import insuranceClaims from '@/API/insurance-claim';
import insuranceCompany from '@/API/insurance-company';
import auth from './auth';
import companies from './companies';
import contact from './contact';
import dashboard from './dashboard';
import Employee from './employees';
import logs from './logs';
import notes from './notes';
import notification from './notification';
import reportError from './report-error';
import reports from './reports';
import store from './store';
import tabs from './tabs';
import uploadFile from './upload-files';
import workersComp from './workers-comp';
import upload from './upload';
import paymentPosting from './payment-posting';
import patients from './patients';
import roles from './roles';
import user from './users';
import userRoles from './user-roles';
import permissions from './permissions';
import rolePermissions from './role-permissions';
import userPermissions from './user-permissions';
import userCompanies from './user-companies';
import outcomeStatus from './outcome-status';
import resources from './resources';

const parent = {
  insuranceClaims,
  insuranceCompany,
  store,
  Employee,
  dashboard,
  auth,
  companies,
  workersComp,
  notification,
  uploadFile,
  contact,
  reportError,
  tabs,
  reports,
  upload,
  paymentPosting,
  patients,
  roles,
  user,
  userRoles,
  permissions,
  rolePermissions,
  userPermissions,
  userCompanies,
  outcomeStatus,
  resources,
  notes,
  logs,
};

export default parent;
